module.exports = __webpack_public_path__ + "static/media/Beu-Marketplace2.428ba0da.png";